export const nodeSnapshotHandlerEventName = (nodeId: number) => `NODE_SNAPSHOT_HANDLER.${nodeId}`;
export const nodeSnapshotHandlerRequestEventName = (nodeId: number) => `NODE_SNAPSHOT_HANDLER_REQUEST.${nodeId}`;
